import React, { useState, useEffect } from 'react';
import apiService from '../../services/api.service';
import ProfileForm from '../../components/ProfileForm';
import PasswordChangeForm from '../../components/PasswordChangeForm';
import './Profile.css';

const Profile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.getProfile();
      if (response.data.success) {
        setUser(response.data.data.user);
      } else {
        setError('Failed to load profile');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load profile');
      console.error('Profile fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleProfileUpdate = async (data) => {
    try {
      setError(null);
      setSuccessMessage('');
      const response = await apiService.updateProfile(data);
      if (response.data.success) {
        setUser(response.data.data.user);
        setSuccessMessage('Profile updated successfully!');
        setTimeout(() => setSuccessMessage(''), 5000);
      } else {
        setError(response.data.error || 'Failed to update profile');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update profile');
      console.error('Profile update error:', err);
    }
  };

  const handlePasswordChange = async (data) => {
    try {
      setError(null);
      setSuccessMessage('');
      const response = await apiService.changePassword(data);
      if (response.data.success) {
        setSuccessMessage('Password changed successfully!');
        setTimeout(() => setSuccessMessage(''), 5000);
      } else {
        setError(response.data.error || 'Failed to change password');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password');
      console.error('Password change error:', err);
    }
  };

  if (loading) {
    return (
      <div className="profile-container">
        <div className="loading">Loading profile...</div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-header">
        <h2>Admin Profile</h2>
        {user && (
          <div className="profile-info">
            <div className="info-item">
              <span className="label">Status:</span>
              <span className={`status ${user.status === '1' ? 'active' : 'inactive'}`}>
                {user.status === '1' ? 'Active' : 'Inactive'}
              </span>
            </div>
          </div>
        )}
      </div>

      {error && (
        <div className="alert alert-error">
          <strong>Error:</strong> {error}
        </div>
      )}

      {successMessage && (
        <div className="alert alert-success">
          <strong>Success:</strong> {successMessage}
        </div>
      )}

      {user && (
        <>
          <ProfileForm 
            user={user}
            onUpdate={handleProfileUpdate}
            loading={loading}
          />

          <PasswordChangeForm 
            onPasswordChange={handlePasswordChange}
            loading={loading}
          />
        </>
      )}
    </div>
  );
};

export default Profile;

